import type { GlobalError } from 'react-hook-form/dist/types/errors';
import type { IntlShape } from 'react-intl';
import { useIntl } from 'react-intl';
import styled, { css } from 'styled-components';

import { Typography } from '@/components/Typography';
import type { Maybe, WithHTMLProp } from '@/lib/types';
import { formMessages } from '@/messages/forms';

export const ErrorMessage = styled(Typography)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p3};
    color: ${theme.colors.error};
  `}
`;

const getErrorMessage = (
  error: Maybe<GlobalError>,
  formatMessage: IntlShape['formatMessage'],
) => {
  if (!error) return '';

  // Customize the message based on the error type
  switch (error.type) {
    case 'min':
      return error.message;
    case 'email':
      return formatMessage(formMessages.invalidEmailAddress);
    default:
      return error.message;
  }
};

export interface InputErrorMessageProps extends WithHTMLProp<'className'> {
  error: Maybe<GlobalError>;
}

export const InputErrorMessage = ({
  error,
  ...props
}: InputErrorMessageProps) => {
  const { formatMessage } = useIntl();

  if (!error) return null;
  return (
    <ErrorMessage {...props} data-test-id='InputErrorMessage'>
      {getErrorMessage(error, formatMessage)}
    </ErrorMessage>
  );
};
